import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button, Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';

import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../../store/actions';
import { Constant } from '../../../../../../Helpers/constant';
import CardViewActiveImg from './../../../../../../../assets/custom/card-view-active.png';
import CardViewImg from './../../../../../../../assets/custom/card-view.png';
import TabularViewActiveImg from './../../../../../../../assets/custom/tabular-view-active.png';
import TabularViewImg from './../../../../../../../assets/custom/tabular-view.png';
import CardView from './CardView';
import TabularView from './TabularView';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

const DataViews = ({
  data,
  titleText,
  updateURLParams,
  skip,
  limit,
  setCurrentSelectedBooking,
  selectedBooking,
  setCurrentActiveBookingAction,
  bookingType = '',
  appliedName = '',
  isMultiSelectable = false,
  setIsMultiSelectable = null,
  shouldHaveClearSelection = false,
  setShouldHaveClearSelection,
  filterSubmitHandler,
  currentlyAppliedFilters,
  assignedToMeFilter,
  setAssignedToMeFilter,
  secondaryFiltersList,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  console.log('data', limit);

  /* ---------------------------- LOCAL STATE ---------------------------- */
  const [isTabularView, setIsTabularView] = useState(
    Constant?.userTypes?.VENDOR_USER_V2 === parseInt(localStorage.getItem('userType')) ? false : true,
  );

  useEffect(() => {
    if (data?.result?.length > 0 && Constant?.userTypes?.VENDOR_USER_V2 === parseInt(localStorage.getItem('userType'))) {
      if (
        data?.result?.[0]?.bookingType === `airport_transfers` &&
        (data?.result?.[0]?.actions?.includes('complete_booking') || data?.result?.[0]?.actions?.includes('vendor_accept'))
      ) {
        setIsTabularView(true);
        setIsMultiSelectable(true);
      } else {
        // setIsTabularView(false);
        setIsMultiSelectable(false);
      }
    }
  }, [data?.result]);

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const handleRowsPerPageChange = newRowsPerPage => {
    updateURLParams({ skip: 1, limit: newRowsPerPage });
  };

  const paginationHandler = pageNumber => {
    updateURLParams({ skip: pageNumber + 1, limit: limit });
  };

  const toggleView = () => {
    setIsTabularView(!isTabularView);
    setCurrentSelectedBooking(null);
    setCurrentActiveBookingAction(null);

    setShouldHaveClearSelection(true);
    setTimeout(() => {
      setShouldHaveClearSelection(false);
    }, 1000);

    updateURLParams({ skip: 1, limit: limit });
    dispatch({
      type: GET_BOOKING_DETAILS_EMPTY,
    });
  };

  const routeHandler = () => {
    const params = {
      id: selectedBooking?.[0]?.id,
    };
    history.push({
      pathname: selectedBooking?.[0]?.configurationType === 'program_onboarding' ? '/v2/program-onboarding' : '/v2/vendor-onboarding',
      search: `?${queryString.stringify(params)}`,
    });
  };

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-end">
              <h4 className="card-title mb-0 flex-grow-1 custom-card-title"> {titleText} </h4>

              <div className="d-flex gap-3">
                {isTabularView && (
                  <div className="d-flex gap-2">
                    <>
                      {selectedBooking?.length === 1 && (
                        <>
                          {[
                            { action: 'approve_airport', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'revoke_configuration', label: 'Revoke', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_airport', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_zone', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_zone', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_vendor', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_vendor', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_client', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_client', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_vendor_pricing', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_vendor_pricing', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_client_pricing', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_client_pricing', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'approve_client_zone', label: 'Accept', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'reject_client_zone', label: 'Reject', className: 'customized-btn-reject fw-medium fs-11' },
                            { action: 'publish_airport', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'publish_vendor', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'publish_client', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            { action: 'publish_zone', label: 'Publish', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                            // { action: 'seek_approval', label: 'Seek Approval', className: 'btn btn-primary fw-medium fs-11', color: 'primary' },
                          ].map(({ action, label, className, color }) =>
                            selectedBooking[0]?.actions?.includes(action) ? (
                              <Button key={action} className={className} color={color} onClick={() => setCurrentActiveBookingAction(action)}>
                                {label}
                              </Button>
                            ) : null,
                          )}
                        </>
                      )}

                      {selectedBooking?.length === 1 && selectedBooking[0]?.actions?.includes('edit_configuration') && (
                        <Button className="customized-btn d-flex align-items-center gap-1" onClick={routeHandler} color="primary">
                          <i className="ri-edit-line"></i>
                          <span>Edit Configuration</span>
                        </Button>
                      )}

                      {selectedBooking?.length === 1 && selectedBooking[0]?.actions?.includes('publish_config') && (
                        <Button
                          className="customized-btn d-flex align-items-center gap-1"
                          onClick={() => setCurrentActiveBookingAction('publish_config')}
                          color="primary"
                        >
                          <span>Publish Config</span>
                        </Button>
                      )}
                      {/* ********************** MULTIPLE SELECTION ACTIONS LIST - END ********************** */}
                    </>
                  </div>
                )}

                <div className="d-flex gap-2 align-items-center">
                  {isTabularView ? (
                    <img src={CardViewImg} className="view-img" onClick={toggleView} />
                  ) : (
                    <img src={CardViewActiveImg} className="view-img" onClick={toggleView} />
                  )}
                  {isTabularView ? (
                    <img src={TabularViewActiveImg} className="view-img" onClick={toggleView} />
                  ) : (
                    <img src={TabularViewImg} className="view-img" onClick={toggleView} />
                  )}
                </div>
              </div>
            </CardHeader>

            <CardBody
              style={{
                zIndex: 0,
              }}
            >
              {isTabularView ? (
                <TabularView
                  data={data?.result}
                  schema={data?.schema?.tabularView}
                  totalCount={data?.totalCount}
                  skip={skip}
                  limit={limit}
                  handleRowsPerPageChange={handleRowsPerPageChange}
                  handlePageChange={paginationHandler}
                  setCurrentSelectedBooking={setCurrentSelectedBooking}
                  selectedBooking={selectedBooking}
                  isTableDisplay={true}
                  bookingType={bookingType}
                  appliedName={appliedName}
                  isMultiSelectable={isMultiSelectable}
                  shouldHaveClearSelection={shouldHaveClearSelection}
                />
              ) : (
                <>
                  <CardView
                    data={data?.result}
                    schema={data?.schema?.cardView}
                    isMultiSelectable={isMultiSelectable}
                    currentSelectedBooking={selectedBooking}
                    setCurrentSelectedBooking={setCurrentSelectedBooking}
                    setCurrentActiveBookingAction={setCurrentActiveBookingAction}
                  />
                  <TabularView
                    data={data?.result}
                    schema={data?.schema?.tabularView}
                    totalCount={data?.totalCount}
                    skip={skip}
                    limit={limit}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    handlePageChange={paginationHandler}
                    setCurrentSelectedBooking={setCurrentSelectedBooking}
                    isTableDisplay={(data?.result?.length ?? 0) === 0 ? true : false}
                    bookingType={bookingType}
                    isMultiSelectable={isMultiSelectable}
                    shouldHaveClearSelection={shouldHaveClearSelection}
                  />
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DataViews;
